import { combineReducers } from '@reduxjs/toolkit';

import reportAdminReducer from './Report/slice';

export default combineReducers({
  report: reportAdminReducer,
});
